import PanelBanner from './PanelBanner';
export default PanelBanner;